import { render } from "./user-menu.vue?vue&type=template&id=4b60a978&scoped=true"
import script from "./user-menu.vue?vue&type=script&lang=js"
export * from "./user-menu.vue?vue&type=script&lang=js"

import "./user-menu.vue?vue&type=style&index=0&id=4b60a978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b60a978"]])

export default __exports__